<template>
    <div class="textarea-field" :class="{ '--has-counter': hasCounterSMS, 'error': isError, 'repeat-error': repeatError }">
        <textarea-autosize :class="classTextareaField"
                  :id="inputId"
                  ref="textField"
                  :auto-focus="autoFocus"
                  @keyup.enter="enter()"
                  @focus.native="setFocus(true)"
                  @blur.native="setFocus(false)"
                  :disabled="disabled"
                  v-model="inputVal"
                  :style="addStyle"
                  @input="updateValue"
                  :placeholder="placeholder"
                  :autoResizeOnFocus="autoResizeOnFocus"
                  :resizable="resize"></textarea-autosize>
        <div v-if="isError && errorText" class="textarea-error">{{ errorText }}</div>

        <div class="textarea-counter" v-if="hasCounterSMS"> символов: <span>{{counterSimbols}}</span> из {{counterSmsLength}} &nbsp;|&nbsp; кол-во СМС: <span data-target="#sms-area1" class="js-sms-count">{{counterSMS}}</span></div>
    </div>
</template>

<script>
    import {scrollToModal} from '@/helpers/animate.js';
    import TextareaAutosize from '@/components/forms/TextareaAutosize.vue'
    export default {
        components: {
            TextareaAutosize
        },
        name: "TextareaField",
        props: {
            autoResizeOnFocus: {default: true},
            value: {default: ''},
            placeholder: {default: ''},
            inputId: {default: ''},
            disabled: {default: false},
            isError: {default: false},
            isEdit: {default: false},
            addStyle: {default: ''},
            autoFocus: {default: false},
            isValidate: {default: false},
            errorText: {default: 'Не менее 10-ти символов'},
            resize: {default: false},
            classTextarea: {
                default(){
                    return []
                },
                type: Array,
            },
            hasCounterSMS: {default: false},
        },
        data: function () {
            return {
                focus: false,
                counterSMS: 0,
                counterSimbols: 0,
                counterSmsLength: 70,
                repeatError: false,
            }
        },
        watch:{
            isError(val,oldVal){
                if(this.isError){
                    if(this.$el.closest('.popup-wrapper')){
                        let $top = 0;
                        let pr = this.$el.closest('.popup-wrapper');
                        $top += parseFloat(pr.offsetTop);
                        pr.scrollTo({top: $top, left: 0, behavior: 'smooth'});
                    }
                }
                if(oldVal){
                    this.repeatError = true;
                }
            }
        },
        computed: {
            showLabel() {
                return this.focus || this.inputVal.toString().length > 0
            },
            classTextareaField() {
                return { error: this.isError, 'repeat-error': this.repeatError, ...this.classTextarea }
            },
            inputVal:{
                get() { return this.value },
                set(value) { this.input = value},
            }
        },
        mounted() {

        },
        methods: {
            updateValue: function (value) {
                this.$emit('input', value);
                if(this.hasCounterSMS){
                    this.symbolsCounter(value);
                }
            },
            enter: function () {
                this.$emit('enter')
            },
            check: function () {
                this.$emit('check')
            },
            setFocus(value) {
                let self = this
                value = value || false;
                this.focus = value;
                this.repeatError = false;
                if(value){
                    this.$emit('focus');
                } else {
                    this.$emit('blur');
                }
            },
            edit: function () {
                this.$emit('edit');
            },
            symbolsCounter (value){
                let newLinesymbols, keptlength;
                // \n - в FF - это один символ, в IE - два, поэтому вынуждены делать так. Определяем, IE это или нет
                if (value.match(/\r/g) == null) {
                    //считаем количество символов
                    let newLinesymbols = value.match(/\n/g);
                }
                let newLinesymbolsCount = (newLinesymbols != null) ? newLinesymbols.length : 0;
                //исходя из хака считаем количество символов
                let textLength = value.length + newLinesymbolsCount;
                //определяем длину части
                let messLenPart = (textLength) > 70 ? 67 : 70;

                let parts = Math.ceil(textLength / messLenPart);
                if (textLength % messLenPart) {
                    keptlength = textLength % messLenPart;
                    /*if(parts>1){
                        keptlength = keptlength+3;
                    }*/
                }
                else {
                    if (textLength == 0)
                        keptlength = 0;
                    else
                        keptlength = messLenPart;
                }

                this.counterSMS = parts;
                this.counterSmsLength = messLenPart;
                this.counterSimbols = keptlength;
            }
        }
    }
</script>

<style>

</style>
